<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeTutorTask
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2973-37221
 */
import type { BadgeTutorTaskProps } from '../types/interfaces'

import { useBadgeTutorTask } from '../composables/use-badge-tutor-task.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeTutorTask',
})

const props = defineProps<BadgeTutorTaskProps>()

const {
  color,
  text,
} = useBadgeTutorTask({ props })
</script>

<template>
  <AppBadge
    :color="color"
    :text="text"
  />
</template>
